module.exports = __webpack_public_path__ + "static/about-img-a8071c1cdd7166714546cd5eb697e255.svg";